// src/SessionExpired.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import VisitOMSLogo from './VisitOMS_logo.png';

const SessionExpired = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-slate-100">
      <div className="min-h-screen flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md">
          <div className="rounded-3xl border border-slate-200 bg-white shadow-sm overflow-hidden">
            {/* top accent */}
            <div className="h-2 bg-gradient-to-r from-violet-600 via-indigo-600 to-sky-600" />

            <div className="p-6 sm:p-7 text-center">
              {/* HEADER */}
              <div className="flex flex-col items-center mb-5">
                <img
                  src={VisitOMSLogo}
                  alt="VisitOMS logo"
                  className="w-14 h-14 sm:w-16 sm:h-16 mb-3 object-contain"
                />

                <h1 className="text-xl sm:text-2xl font-extrabold tracking-tight text-slate-900">
                  Session expired
                </h1>

                <p className="text-sm text-slate-600 mt-2 leading-snug">
                  For security, we signed you out automatically after a period of inactivity.
                </p>

                <div className="mt-3 inline-flex items-center gap-2">
                  <span className="text-[11px] px-2 py-0.5 rounded-full border border-slate-200 bg-slate-50 text-slate-700 font-semibold">
                    Secure sign-out
                  </span>
                  <span className="text-[11px] text-slate-500">Please sign in again</span>
                </div>
              </div>

              <p className="text-[12px] text-slate-600 mb-4">
                Choose how you want to sign in:
              </p>

              <div className="flex flex-col gap-2 text-left">
                {/* 1) Standard login */}
                <button
                  onClick={() => navigate('/login', { replace: true })}
                  className="w-full py-3.5 rounded-2xl bg-sky-600 text-white text-sm font-extrabold hover:bg-sky-700 transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                >
                  Standard login (email &amp; password)
                </button>

                {/* 2) Teacher / Provider magic link */}
                <button
                  onClick={() => navigate('/teacher-login', { replace: true })}
                  className="w-full py-3.5 rounded-2xl border border-slate-200 bg-white text-slate-900 text-sm font-extrabold hover:bg-slate-50 transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                >
                  Teacher / Provider – get Magic Link
                  <div className="mt-1 text-[11px] font-semibold text-slate-500">
                    Send a secure sign-in link to your work email
                  </div>
                </button>

                {/* 3) Parent magic link */}
                <button
                  onClick={() => navigate('/parent-login', { replace: true })}
                  className="w-full py-3.5 rounded-2xl border border-slate-200 bg-white text-slate-900 text-sm font-extrabold hover:bg-slate-50 transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                >
                  Parent – get Magic Link
                  <div className="mt-1 text-[11px] font-semibold text-slate-500">
                    Receive a secure sign-in link by email
                  </div>
                </button>
              </div>

              <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-left">
                <p className="text-[12px] font-extrabold text-slate-900">Need help?</p>
                <p className="text-[12px] text-slate-600 mt-1 leading-snug">
                  If you believe this is a mistake, please contact your agency administrator.
                </p>
              </div>

              <div className="mt-4 text-center">
                <button
                  type="button"
                  onClick={() => window.open('https://visitoms.com', '_blank')}
                  className="text-xs font-semibold text-sky-700 hover:text-sky-800 hover:underline"
                >
                  About VisitOMS
                </button>
              </div>
            </div>
          </div>

          <p className="text-center text-[11px] text-slate-500 mt-4 px-2 leading-snug">
            For security, we don&apos;t keep sessions active indefinitely on shared devices.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SessionExpired;



